import React, { useState } from 'react';
import { A2UISurfaceRenderer } from '../components/ChatComponents';
import { A2UI_EXAMPLES } from '../utils/a2uiExamples';
import { RUN_REPORT_EXAMPLES } from '../utils/runReportExamples';

const EXAMPLES = [...A2UI_EXAMPLES, ...RUN_REPORT_EXAMPLES];

// A2UI render preview harness. Feeds static v1.0 wire examples
// through the SAME A2UISurfaceRenderer the playground and user views use — no
// forked render path — so a surface that renders here renders identically in a
// real chat. Verifies happy-path surfaces plus edge behavior (unknown-component
// skip, empty-surface rejection, legacy v0.9 fallback) without a chat round-trip.
const A2UIPreview: React.FC = () => {
  const [interactive, setInteractive] = useState(false);

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-semibold text-slate-900">A2UI 렌더 프리뷰</h1>
          <p className="text-sm text-slate-500">
            정적 v1.0 wire → 실 채팅과 동일한 렌더러. 컴포넌트/봉투 회귀를 채팅 왕복 없이 확인.
          </p>
        </div>
        <label className="flex items-center gap-2 text-sm text-slate-600">
          <input
            type="checkbox"
            checked={interactive}
            onChange={(e) => setInteractive(e.target.checked)}
          />
          interactive
        </label>
      </div>

      {EXAMPLES.map((ex) => (
        <section key={ex.key} className="rounded-lg border border-slate-200 bg-white">
          <header className="border-b border-slate-100 px-4 py-2">
            <h2 className="text-sm font-medium text-slate-800">{ex.label}</h2>
            {ex.note && <p className="mt-0.5 text-xs text-slate-500">{ex.note}</p>}
          </header>
          <div className="grid grid-cols-1 gap-0 md:grid-cols-2">
            <div className="border-slate-100 px-4 py-3 md:border-r">
              <div className="mb-1 text-xs font-medium uppercase tracking-wide text-slate-400">
                rendered
              </div>
              <A2UISurfaceRenderer
                surface={ex.surface}
                isInteractive={interactive}
                onSubmit={(msg) => {
                  // eslint-disable-next-line no-console
                  console.info('[A2UIPreview] onSubmit:', msg);
                }}
                onSurfaceAction={(action, label) => {
                  console.info('[A2UIPreview] onSurfaceAction:', label, action);
                }}
              />
            </div>
            <div className="px-4 py-3">
              <div className="mb-1 text-xs font-medium uppercase tracking-wide text-slate-400">
                wire
              </div>
              <pre className="overflow-x-auto rounded bg-slate-50 p-2 text-xs text-slate-700">
                {JSON.stringify(ex.surface, null, 2)}
              </pre>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default A2UIPreview;
